import React, { useEffect } from 'react'
import { Link } from "react-router-dom";
import styles from "./gallery.module.scss"
import testIcon from "images/test.png"
import { Skeleton, Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import Tooltip from '@mui/material/Tooltip';

const Gallery = (props) => {
  const Card = (data) => {
    const layoutData = props.layouts.find(layout => {
      return data.instance[3] === layout[0]
    })
    const industriesData = props.industries.find(industry => {
      return data.instance[4] === industry[0]
    })
    const featuresData = props.features.find(feature => {
      return layoutData[4] === feature[0]
    })
    return (
      <Link to={linkRender(data)} style={{ textDecoration: 'none' }}>
        <div className={styles.card}>
          <img className="flexImg" alt="topImg" src={data.instance[6]} />
          <div className={styles.bottom}>
            <div>
              <div className={styles.content}>
                {cardContentRender(data, layoutData)}
              </div>
              <div className={styles.tag}>
                {industryRender(industriesData)}
                {featureRender(featuresData)}
              </div>
            </div>
            <div>
              {/* <img className={styles.testIcon} alt='testIcon' src={testIcon} /> */}
            </div>
          </div>
        </div>
      </Link>
    )
  }
  const radioValueFilter = (data, categoryArray) => {
    for (var i = 0; i < data.length; i++) {
      if (data[i].includes(',')) {
        let array = data[i].split(',');
        for (var j = 0; j < array.length; j++) {
          if (categoryArray.includes(array[j].trim())) {
            return data
          }
        }
      }
      if (categoryArray.includes(data[i])) {
        return data
      }
    }
  }
  const cardContentRender = (data, layoutData) => {
    switch (props.searchParams.get("lang")) {
      case 'en':
        return (
          <>
            <Tooltip placement="top-start" title={data.instance[2]}>
              <p className="title">{data.instance[2]}</p>
            </Tooltip>
            <Tooltip placement="top-start" title={layoutData ? layoutData[2] : ''}>
              <span>{layoutData ? layoutData[2] : ''}</span>
            </Tooltip>
          </>
        )
      default:
        return (
          <>
            <Tooltip placement="top-start" title={data.instance[1]}>
              <p className="title">{data.instance[1]}</p>
            </Tooltip>
            <Tooltip placement="top-start" title={layoutData ? layoutData[1] : ''}>
              <span>{layoutData ? layoutData[1] : ''}</span>
            </Tooltip>
          </>
        )
    }
  }
  const industryRender = (industriesData) => {
    switch (props.searchParams.get("lang")) {
      case 'en':
        return industriesData ? <button>{industriesData[2]}</button> : null
      default:
        return industriesData ? <button>{industriesData[1]}</button> : null
    }
  }
  const featureRender = (featuresData) => {
    switch (props.searchParams.get("lang")) {
      case 'en':
        return featuresData ? <button>{featuresData[2]}</button> : null
      default:
        return featuresData ? <button>{featuresData[1]}</button> : null
    }
  }
  const linkRender = (data) => {
    switch (props.searchParams.get("lang")) {
      case 'en':
        return `/instance/${data.instance[0]}/?lang=en`
      default:
        return `/instance/${data.instance[0]}`
    }
  }
  const searchData = (data) => {
    switch (props.searchParams.get("lang")) {
      case 'en':
        return data[2].toLowerCase().includes(props.inputValue.trim().toLowerCase())
      default:
        return data[1].toLowerCase().includes(props.inputValue.trim().toLowerCase())
    }
  }
  return !props.data ?
    (
      <main className={styles.gallery}>
        <div className={styles.search}>
          <div>
            <button className={styles.searchButton}>
              <SearchIcon />
              <input type="text" onChange={(e) => props.getInputValue(e.target.value)} />
            </button>
          </div>
        </div>
        <div className={styles.container}>
          {Array.from({ length: 12 }).map((_, index) => (
            <div key={index} className={`${styles.card} flexFont`}>
              <Skeleton animation="wave" variant="rectangular" width={320} height={170} />
              <Box sx={{ padding: '20px' }}>
                <Skeleton animation="wave" height={10} style={{ marginBottom: 8 }} />
                <Skeleton animation="wave" height={10} style={{ marginBottom: 8 }} width="80%" />
                <Skeleton animation="wave" height={10} width="40%" />
              </Box>
            </div>
          ))}
        </div>
      </main>
    ) : (
      <main className={styles.gallery}>
        <div className={styles.search}>
          <div>
            <button className={styles.searchButton}>
              <SearchIcon />
              <input onChange={(e) => props.getInputValue(e.target.value)} />
            </button>
          </div>
        </div>
        <div className={styles.container}>
          {props.data.filter(data => {
            if (data[11]) {
              return data[11].trim().toLowerCase() !== 'true'
            }
            return data
          }).map((data) => {
            const layoutData = props.layouts.find(layout => {
              return data[3] === layout[0]
            })
            if (layoutData) {
              const dataKeys = layoutData.slice(3, 7);
              const mergeData = data.concat(dataKeys)
              return mergeData
            } else {
              return data
            }
          }).filter(data => {
            if (props.inputValue.trim() === '') {
              return data;
            } else if (searchData(data)) {
              return data;
            }
          }).filter(data => {
            if (props.layoutsFilter && props.layoutsFilter.length !== 0) {
              return radioValueFilter(data, props.layoutsFilter)
            } else {
              return data
            }
          }).filter(data => {
            if (props.placementsFilter && props.placementsFilter.length !== 0) {
              return radioValueFilter(data, props.placementsFilter)
            } else {
              return data
            }
          }).filter(data => {
            if (props.featuresFilter && props.featuresFilter.length !== 0) {
              return radioValueFilter(data, props.featuresFilter)
            } else {
              return data
            }
          }).filter(data => {
            if (props.industriesFilter && props.industriesFilter.length !== 0) {
              return radioValueFilter(data, props.industriesFilter)
            } else {
              return data
            }
          }).filter(data => {
            if (props.devicesFilter && props.devicesFilter.length !== 0) {
              return radioValueFilter(data, props.devicesFilter)
            } else {
              return data
            }
          }).filter(data => {
            if (props.performancesFilter && props.performancesFilter.length !== 0) {
              return radioValueFilter(data, props.performancesFilter)
            } else {
              return data
            }
          }).filter(data => {
            if (props.deliverySystemsFilter && props.deliverySystemsFilter.length !== 0) {
              return radioValueFilter(data, props.deliverySystemsFilter)
            } else {
              return data
            }
          }).map((data) => <Card key={data[0]} instance={data} />
          )}
        </div>
      </main>
    )
}
export default Gallery